
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Schwanger zu werden, kann vorübergehend Erleichterung bringen: Bei 50 bis 80
Prozent der schwangeren Frauen lassen die Migräneanfälle deutlich nach, am
stärksten in den letzten beiden Dritteln der Schwangerschaft (bei acht Prozent
nehmen die Kopfschmerzen aber zu). Ob das den konstant hohen Hormonspiegeln zu
verdanken ist, den zusätzlichen Endorphinen im Blut, dem veränderten
Serotonin-Stoffwechsel im Hirn und/oder dem meist ruhigeren Lebensstil während
der Schwangerschaft, ist offen. Im Wochenbett setzen die Migräneanfälle meist
wieder ein, und Stillen nützt vermutlich nichts, um sie zu reduzieren.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;